// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select::part(text) {
  display: none;
}

ion-select::part(icon) {
  display: none;
}

.menu-content {
  --padding-bottom: 0;
}

.menu-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
}

ion-menu {
  --width: 300px;
}

ion-item-divider {
  --background: var(--ion-color-light);
  --color: var(--ion-color-medium);
  font-size: 0.8em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  min-height: 30px;
}

ion-list {
  padding: 0;
  margin: 0;
}

ion-item {
  --padding-start: 16px;
  --inner-padding-end: 16px;
  --min-height: 48px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/home/coach-home.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,oCAAA;EACA,gCAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,UAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,yBAAA;EACA,kBAAA;AACF","sourcesContent":["ion-select::part(text) {\r\n  display: none;\r\n}\r\n\r\nion-select::part(icon) {\r\n  display: none;\r\n}\r\n\r\n.menu-content {\r\n  --padding-bottom: 0;\r\n}\r\n\r\n.menu-footer {\r\n  position: fixed;\r\n  bottom: 0;\r\n  width: 100%;\r\n  z-index: 100;\r\n}\r\n\r\nion-menu {\r\n  --width: 300px;\r\n}\r\n\r\nion-item-divider {\r\n  --background: var(--ion-color-light);\r\n  --color: var(--ion-color-medium);\r\n  font-size: 0.8em;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  font-weight: 600;\r\n  min-height: 30px;\r\n}\r\n\r\nion-list {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\nion-item {\r\n  --padding-start: 16px;\r\n  --inner-padding-end: 16px;\r\n  --min-height: 48px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
